/**
 * ActivateButton component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Props from '@shared/types/props/pressable';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled activate button.
 */
const ActivateButton = styled.button<Props>`
  align-items: center;
  background: ${(props) =>
    props.displayBackground
      ? `linear-gradient(
          0deg,
          ${Colors['modal']['button']['border']},
          ${Colors['modal']['button']['gradient']}
          )`
      : 'none'};
  border: ${(props) =>
    props.displayBackground
      ? 'none'
      : `${Colors['modal']['button']['border']} ${
          3 * Screen.widthRatio
        }px solid`};
  border-radius: ${40 * Screen.widthRatio}px;
  color: ${(props) =>
    props.displayBackground
      ? `${Colors['modal']['button']['text']}`
      : `${Colors['modal']['button']['border']}`};
  cursor: pointer;
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${34 * Screen.widthRatio}px;
  height: ${80 * Screen.widthRatio}px;
  justify-content: center;
  width: ${500 * Screen.widthRatio}px;
  z-index: 1;
  &:hover {
    background: linear-gradient(
      0deg,
      ${Colors['modal']['button']['border']},
      ${Colors['modal']['button']['gradient']}
    );
    border: none;
    color: ${Colors['modal']['button']['text']};
  }
`;

export default withOpacity(ActivateButton);
